'use client'

import { useCallback, useEffect, useRef } from 'react'

import { EventTypes, SSEEventData } from '@marketplace-web/messaging/sse-connection-data'
import { useMessagingSSEConnection } from '@marketplace-web/messaging/sse-connection-feature'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

export const useHandleConversationSSE = () => {
  const { conversation, getConversationRequest } = useConversationContext()
  const getConversationRequestRef = useRef(getConversationRequest)
  const { subscribeToMessageUpdates, unsubscribeFromMessageUpdates } = useMessagingSSEConnection()

  useEffect(() => {
    getConversationRequestRef.current = getConversationRequest
  }, [getConversationRequest])

  const handleMessageUpdate = useCallback(
    (data: SSEEventData) => {
      const sseConversationId = data.data.user_msg_thread_id

      if (data.message_type !== EventTypes.RefreshConversation) return
      if (!conversation?.id || sseConversationId !== Number(conversation?.id)) return

      getConversationRequestRef.current({
        conversationId: conversation?.id,
        fromPostReply: false,
      })
    },
    [conversation?.id],
  )

  useEffect(() => {
    if (!conversation?.id) return undefined

    subscribeToMessageUpdates(handleMessageUpdate)

    return () => {
      unsubscribeFromMessageUpdates(handleMessageUpdate)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleMessageUpdate])
}
